import { render, staticRenderFns } from "./CrossAllowanceYearBoundaryError.vue?vue&type=template&id=8a7e1ec4"
import script from "./CrossAllowanceYearBoundaryError.vue?vue&type=script&lang=js"
export * from "./CrossAllowanceYearBoundaryError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports